import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config";
import "./AdminNotifications.css";

const serverConfig = { withCredentials: true };

const AdminNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [message, setMessage] = useState("");
  const [link, setLink] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const load = () => {
    axios
      .get(`${config.apiUrl}/api/v1/admin/notifications`, serverConfig)
      .then(({ data }) => setNotifications(data.notifications))
      .catch(() => {});
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSaving(true);
    setError("");
    try {
      await axios.post(
        `${config.apiUrl}/api/v1/admin/notifications`,
        { message, link },
        serverConfig
      );
      setMessage("");
      setLink("");
      load();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create notification.");
    } finally {
      setSaving(false);
    }
  };

  const handleToggle = async (id) => {
    try {
      await axios.put(
        `${config.apiUrl}/api/v1/admin/notifications/${id}/toggle`,
        {},
        serverConfig
      );
      load();
    } catch {}
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this notification?")) return;
    try {
      await axios.delete(
        `${config.apiUrl}/api/v1/admin/notifications/${id}`,
        serverConfig
      );
      load();
    } catch {}
  };

  return (
    <div className="an-page">
      <h1 className="an-heading">Notifications</h1>

      {/* CREATE */}
      <form className="an-form" onSubmit={handleCreate}>
        <div className="an-form-group">
          <label className="an-label">Message</label>
          <textarea
            className="an-textarea"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Announcement text..."
            rows={2}
          />
        </div>
        <div className="an-form-group">
          <label className="an-label">Link (optional)</label>
          <input
            className="an-input"
            type="url"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="https://..."
          />
        </div>
        {error && <p className="an-error">{error}</p>}
        <button className="an-btn-create" type="submit" disabled={saving}>
          {saving ? "Creating..." : "Create Notification"}
        </button>
      </form>

      {/* LIST */}
      <div className="an-list">
        {notifications.length === 0 && (
          <p className="an-empty">No notifications yet.</p>
        )}
        {notifications.map((n) => (
          <div key={n._id} className={`an-card ${n.isActive ? "active" : ""}`}>
            <div className="an-card-body">
              <p className="an-card-message">{n.message}</p>
              {n.link && (
                <a
                  href={n.link}
                  target="_blank"
                  rel="noreferrer"
                  className="an-card-link"
                >
                  {n.link}
                </a>
              )}
              <span className="an-card-date">
                {new Date(n.createdAt).toLocaleDateString("en-GB", {
                  day: "numeric", month: "short", year: "numeric",
                })}
              </span>
            </div>
            <div className="an-card-actions">
              <button
                className={`an-toggle-btn ${n.isActive ? "on" : "off"}`}
                onClick={() => handleToggle(n._id)}
              >
                {n.isActive ? "Active" : "Inactive"}
              </button>
              <button
                className="an-delete-btn"
                onClick={() => handleDelete(n._id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminNotifications;
